/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IProductDetailContainerViewProps } from './product-detail-container';

export default (props: IProductDetailContainerViewProps) => {
    const { details, availability, customClass } = props;
    return (
        <div className={`${customClass}` || 'page'}>
                {details}
                {availability}
        </div>
    );
};
